import {
    GET_INVOICE, GET_INVOICE_SUCCESS, GET_INVOICE_FAIL,
    MAKE_PAYMENT, MAKE_PAYMENT_SUCCESS, MAKE_PAYMENT_FAIL, TOGGLE_PAYMENT_MODEL
} from "./actionTypes"

export const getInvoice = () => ({
    type: GET_INVOICE,
})

export const getInvoiceSuccess = invoiceDetails => ({
    type: GET_INVOICE_SUCCESS,
    payload: invoiceDetails
})

export const getInvoiceFail = error => ({
    type: GET_INVOICE_FAIL,
    payload: error
})

export const makePayment = () => ({
    type: MAKE_PAYMENT,
})

export const makePaymentSuccess = paymentUrl => ({
    type: MAKE_PAYMENT_SUCCESS,
    payload: paymentUrl
})

export const makePaymentFail = error => ({
    type: MAKE_PAYMENT_FAIL,
    payload: error
})

export const togglePaymentModal = modalPayment => ({
    type: TOGGLE_PAYMENT_MODEL,
    payload: modalPayment
})

